"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateShiftSchema = exports.createShiftSchema = exports.shiftShape = void 0;
const zod_1 = require("zod");
const TIME_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;
exports.shiftShape = {
    name: zod_1.z.string().min(1).max(100),
    startTime: zod_1.z.string().regex(TIME_REGEX, 'Expected HH:mm 24-hour format'),
    endTime: zod_1.z.string().regex(TIME_REGEX, 'Expected HH:mm 24-hour format'),
    breakMinutes: zod_1.z.number().int().nonnegative().default(0),
    isNightShift: zod_1.z.boolean().default(false),
    branchId: zod_1.z.string().uuid().optional(),
    // HR Phase 1C — the extended fields Phase 1A's migration added to `shifts`
    // (attendance + roster), now reachable through the admin CRUD.
    code: zod_1.z.string().trim().min(1).max(30).optional(),
    category: zod_1.z.string().trim().min(1).max(20).optional(),
    graceInMinutes: zod_1.z.number().int().nonnegative().max(120).default(0),
    graceOutMinutes: zod_1.z.number().int().nonnegative().max(120).default(0),
    minWorkingMinutes: zod_1.z.number().int().positive().max(1440).optional(),
    isSplit: zod_1.z.boolean().default(false),
    otMultiplier: zod_1.z.coerce.number().positive().max(10).optional(),
};
exports.createShiftSchema = zod_1.z.object(exports.shiftShape);
exports.updateShiftSchema = exports.createShiftSchema.partial();
//# sourceMappingURL=shift.schema.js.map